import { paths } from '@shared/enums/paths';

export const flagBackLinkPathByUserIdCreatePage = (id: string): string => `${paths.users}/${id}`;
